module.exports = __webpack_public_path__ + "8a95b1441584891e09f930b214976528.png";